import { useCallback } from 'react';
import NutritionCharts from '../../components/nutrition/NutritionCharts';
import ErrorMessage from '../../components/ui/ErrorMessage';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useModalNavigation } from '../../context/ModalControllerContext';
import useGetNutritionByMeal from '../../hooks/data/nutrition/useGetNutritionByMeal';
import useOptionalHook from '../../hooks/utils/useOptionalHook';
import ModalHeader from '../components/ModalHeader';
import useFavoriteMeal from '../../hooks/data/meals/useFavoriteMeal';

const ModalFavoriteMealNutrition = ({ favoriteId, title, onRequestClose }) => {
    const { data, isLoading, isError, error } = useGetNutritionByMeal({ favoriteId });
    const {
        data: favoriteMeal,
        isLoading: isLoadingMeal,
        isError: isMealError,
        error: mealError
    } = useFavoriteMeal({ favoriteId });

    const navigation = useOptionalHook(useModalNavigation);

    const handleClose = useCallback(() => {
        if (onRequestClose) onRequestClose();
        else navigation?.close();
    }, [onRequestClose, navigation]);

    const isProcessing = isLoading || isLoadingMeal;
    const hasError = isError || isMealError;

    return (
        <>
            <ModalHeader title={title || 'Måltidsinformation'} onClose={handleClose} showBack={false} />

            <div className={`modal-body meal-nutrition ${isLoading ? 'is-loading' : ''}`}>
                {isProcessing && <LoadingSpinner />}

                {hasError && (
                    <ErrorMessage
                        message={
                            error?.message ||
                            mealError?.message ||
                            'Kunde inte hämta näringsinformation just nu.'
                        }
                    />
                )}

                {!isLoading && !isError && (
                    <NutritionCharts
                        data={data}
                        items={favoriteMeal?.items ?? []}
                        showMacros
                        showDesiredEnergy={false}
                        energyTitle="Energifördelning (E %)"
                    />
                )}
            </div>
        </>
    );
};

export default ModalFavoriteMealNutrition;
